
"use strict";

import tablesort from "tablesort";
import "../common/tablesort_numeric";
import "../common/tablesort_time";

import renderLiveStreamingReport from "./render-live-streaming";
import removeInitialViewClass from "../common/remove-initial-view-class";
import renderReportCSV from "./render-live-streaming-csv";
import fileDownloader from "../common/file-downloader";
import onXHRClickButton from "./onxhr-click-button";

export default (dataUrl, settingOptions = {}) => sb => {
    let form,
        selectedPeriod = null,
        selectedBroadcaster = null,
        selectedChannel = null,
        currentData,
        errorMsg,
        submit,
        submit_download,
        broadcasterList,
        report;

    const maybeShowBroadcasterError = () => {
        const noBroadcasters = selectedBroadcaster.length < 1;
        const noWeeks = sb.find('#period_week > option').length > 0 && selectedPeriod.length < 1;

        if (noBroadcasters || noWeeks) {
            errorMsg.css("display", "block");
            submit[0].disabled = "disabled";
            submit_download[0].disabled = "disabled";

            return true;
        } else {
            errorMsg.css("display", "none");
            submit[0].disabled = null;
            submit_download[0].disabled = null;

            return false;
        }
    };

    const renderReport = (data) => {
        const report = sb.find("div#datagrid_live_streaming");

        emptyDatagridContainer();
        hidePleaseWait();
        sb.append(report, renderLiveStreamingReport(data, settingOptions));
        report.css("display", "block");

        const table = report.query("table");

        if (table.length) {
            tablesort(table[0]);
        }

        sb.notify({type: "tableUpdated"});

        removeInitialViewClass(sb);
    };

    const downloadCSV = data => {
        fileDownloader(
            renderReportCSV(data, settingOptions),
            settingOptions.csvName
        );
    };

    const emptyDatagridContainer = () => {
        sb.empty(sb.find("div#datagrid_live_streaming"));
    };

    const showPleaseWait = () => {
        const wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "block");
    };

    const hidePleaseWait = () => {
        const wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "none");
    };

    const onFormSubmit = e => {
        e.preventDefault();

        emptyDatagridContainer();
        showPleaseWait();

        if (settingOptions.periodIdField !== undefined) {
            selectedPeriod = jQuery("#" + settingOptions.periodIdField).val();
        }

        sb.postApi(dataUrl, { method: "POST", period: selectedPeriod, broadcaster: selectedBroadcaster, channels: selectedChannel, type: "open" }).then(
            data => {
                currentData = data;
                return renderReport(currentData);
            }
        );
    };

    const onClickDownloadCSV = () => {

        if (settingOptions.periodIdField !== undefined) {
            selectedPeriod = jQuery("#" + settingOptions.periodIdField).val();
        }

        const postdata = {
            method: "POST",
            period: selectedPeriod,
            broadcaster: selectedBroadcaster,
            channels: selectedChannel,
            type: "open"
        };

        showPleaseWait();
        sb.postApi(dataUrl, postdata)
            .then(downloadCSV)
            .then(hidePleaseWait);
    };

    return {
        init() {
            form = sb.find("form");
            submit = form.query("#button_submit");
            submit_download = form.query("#button_download_trigger");
            broadcasterList = jQuery('#broadcaster', form);

            if (submit_download.length == 0) {
                submit_download = jQuery("#button_download_trigger");
            }

            errorMsg = form.query("div.invalid_input_message");
            errorMsg.css("display", "none");

            sb.addEvent(form, "submit", onFormSubmit);
            sb.addEvent(sb.find("#button_download_trigger"), "click", onClickDownloadCSV);

            sb.listen({
                periodsSelectionChanged: period => selectedPeriod = period,
                broadcastersSelectionChanged: broadcasters => {
                    selectedBroadcaster = broadcasters;
                    if (!maybeShowBroadcasterError()) {
                        broadcasterList.trigger('option_change');
                    }
                },
                stationsSelectionChanged: stations => selectedChannel = (stations.length) ? stations : [61],
                tableFilter: filter => {
                    if (currentData) {
                        renderReport(currentData, filter);
                    }
                }
            });

            // start default report
            onXHRClickButton(submit[0]);
        },
        destroy() {
            sb.ignore([
                "periodsSelectionChanged",
                "broadcastersSelectionChanged",
                "stationsSelectionChanged",
                "tableFilter"
            ]);

            sb.removeEvent(form, "submit", onFormSubmit);

            form = null;
            errorMsg = null;
            submit = null;
            submit_download = null;
            broadcasterList = null;
        }
    }
};

